import * as __glob_0 from './../accordion.js';
import * as __glob_1 from './../blog-toc.js';
import * as __glob_2 from './../card-border.js';
import * as __glob_3 from './../coins-animation.js';
import * as __glob_4 from './../coins-gravity.js';
import * as __glob_5 from './../counter.js';
import * as __glob_6 from './../cycle.ts';
import * as __glob_7 from './../dots-animation.js';
import * as __glob_8 from './../form.ts';
import * as __glob_9 from './../ghost-posts.js';
import * as __glob_10 from './../infrastructure-card.js';
import * as __glob_11 from './../liquidity-progress.js';
import * as __glob_12 from './../logos-wheel.js';
import * as __glob_13 from './../markets-progress.js';
import * as __glob_14 from './../marquee.js';
import * as __glob_15 from './../nav.ts';
import * as __glob_16 from './../purpose-progress.js';
import * as __glob_17 from './../split.ts';
import * as __glob_18 from './../tab.js';
import * as __glob_19 from './../test.ts';
import * as __glob_20 from './../text-animations.js';
const modules = { "./../accordion.js": __glob_0, "./../blog-toc.js": __glob_1, "./../card-border.js": __glob_2, "./../coins-animation.js": __glob_3, "./../coins-gravity.js": __glob_4, "./../counter.js": __glob_5, "./../cycle.ts": __glob_6, "./../dots-animation.js": __glob_7, "./../form.ts": __glob_8, "./../ghost-posts.js": __glob_9, "./../infrastructure-card.js": __glob_10, "./../liquidity-progress.js": __glob_11, "./../logos-wheel.js": __glob_12, "./../markets-progress.js": __glob_13, "./../marquee.js": __glob_14, "./../nav.ts": __glob_15, "./../purpose-progress.js": __glob_16, "./../split.ts": __glob_17, "./../tab.js": __glob_18, "./../test.ts": __glob_19, "./../text-animations.js": __glob_20 };
// console.log("modules -> []", modules);

// Extend HTMLElement interface to include our custom property
declare global {
  interface HTMLElement {
    _moduleInitialized?: boolean;
  }
}

export function createCycles(dataAttribute = "module") {
  return Array.from(document.querySelectorAll(`[data-${dataAttribute}]`))
    .map((element) => {
      const htmlElement = element as HTMLElement;
      const attributeValue = htmlElement.dataset[dataAttribute];

      // Check if THIS SPECIFIC ELEMENT is already initialized
      if (htmlElement._moduleInitialized) {
        return null; // Skip this specific element
      }

      const modulePath = modules[`./../${attributeValue}.ts`]
        ? `./../${attributeValue}.ts`
        : `./../${attributeValue}.js`;

      if (modules[modulePath]) {
        // Expecting a default export function
        const moduleFn = (
          modules[modulePath] as {
            default: (el: HTMLElement, dataset: DOMStringMap) => any;
          }
        ).default;
        if (typeof moduleFn === "function") {
          try {
            // Mark THIS SPECIFIC ELEMENT as initialized
            htmlElement._moduleInitialized = true;

            return moduleFn(htmlElement, htmlElement.dataset);
          } catch (error) {
            // Remove the flag if initialization fails
            delete htmlElement._moduleInitialized;
            console.warn(
              `Failed to call default function for ${dataAttribute} "${attributeValue}":`,
              error
            );
            return null;
          }
        } else {
          console.warn(
            `Default export is not a function for ${dataAttribute} "${attributeValue}"`
          );
          return null;
        }
      } else {
        console.warn(`${dataAttribute} not found: "${attributeValue}"`);
        return null;
      }
    })
    .filter((item) => item !== null);
}

// Optional: Helper function to manually clear initialization for testing
export function clearModuleInitialization(element: HTMLElement) {
  delete element._moduleInitialized;
}
